// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1gOli","right":"Footer_right__2Oj1r","buttons":"Footer_buttons__1DdhB"};